import { FC, ReactElement } from 'react';
import { ThemeProvider as Provider, createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976D2',
    },
    error: {
      main: '#D32F2F',
    },
    success: {
      main: '#4CAF50',
    },
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
  },
});

export const ThemeProvider: FC<{ children: ReactElement | ReactElement[] }> = ({ children }): React.ReactElement => {
  return <Provider theme={theme}>{children}</Provider>;
};
